import client from './client';

// Notifiche sul telefono (apps/notifiche sul server).
export const leggiNotifiche = () => client.get('/v1/notifiche/');
export const salvaPreferenze = dati => client.patch('/v1/notifiche/', dati);
export const iscriviDispositivo = (iscrizione, dispositivo) => client.post('/v1/notifiche/dispositivi/', { ...iscrizione, dispositivo });
export const togliDispositivo = endpoint => client.delete('/v1/notifiche/dispositivi/', { data: { endpoint } });
export const notificaDiProva = () => client.post('/v1/notifiche/prova/');
export const segnalaPresenza = visibile => client.post('/v1/notifiche/presenza/', { visibile });
export const notificheChat = (contactId, notifiche) => client.post(`/v1/notifiche/chat/${contactId}/`, { notifiche });
